import { t } from 'i18next'

import { DOCUMENT } from 'entities/user/module'

import { TYPE_AGE } from 'shared/constants'

export const typesDocuments = [
  { name: DOCUMENT.ID, option: t('id_passport') },
  { name: DOCUMENT.PASSPORT, option: t('passport') },
  { name: DOCUMENT.BIRTH_CERTIFICATE, option: t('birth_certificate') },
]

export const listAges = [
  { name: TYPE_AGE.ADULTS, option: t('purchase_page.adults_count') },
  { name: TYPE_AGE.CHILDREN, option: t('purchase_page.children_count') },
  {
    name: TYPE_AGE.INFANTS_WITHOUT_SEAT,
    option: t('purchase_page.infants_count'),
  },
]
